import * as React from 'react';

const image1 = require('../resources/preConference/image1.jpg');
const image2 = require('../resources/preConference/image2.jpg');
const image3 = require('../resources/preConference/image3.jpg');
const image4 = require('../resources/preConference/image4.jpg');
const image5 = require('../resources/preConference/image5.jpg');
const image6 = require('../resources/preConference/image6.jpg');
const image7 = require('../resources/preConference/image7.jpg');
const image8 = require('../resources/preConference/image8.jpg');
const image9 = require('../resources/preConference/image9.jpg');
const image10 = require('../resources/preConference/image10.jpg');
const image11 = require('../resources/preConference/image11.jpg');
const image12 = require('../resources/preConference/image12.jpg');
const image13 = require('../resources/preConference/image13.jpg');
const image14 = require('../resources/preConference/image14.jpg');
const image15 = require('../resources/preConference/image15.jpg');
const image16 = require('../resources/preConference/image16.jpg');

export const EventsWorkshop = () => (
  <div>
    <div className="fl w-100">
      <p className="tc pv2 fw5 f2 bg_orange white">Events & Workshop</p>
    </div>
    <div className="fl w-100">
      <p className="f3 fw5 mb0 pt3 tc underline">Pre-Conference</p>
    </div>
    <div className="center ph3-ns">
      <div className="cf ph2-ns">
        <div className="fl w-100 pa2">
          <div className="mw9 center">
            <div className="cf pv4 ph5">
              <div className="fl w-100 w-25-ns pa2 tc">
                <img src={image1} className="preConferenceImage" alt="image1" />
              </div>
              <div className="fl w-100 w-25-ns pa2 tc">
                <img src={image2} className="preConferenceImage" alt="image2" />
              </div>
              <div className="fl w-100 w-25-ns pa2 tc">
                <img src={image3} className="preConferenceImage" alt="image3" />
              </div>
              <div className="fl w-100 w-25-ns pa2 tc">
                <img src={image5} className="preConferenceImage" alt="image5" />
              </div>

              <div className="fl w-100 w-25-ns pa2 tc">
                <img src={image4} className="preConferenceImage" alt="image4" />
              </div>           
              <div className="fl w-100 w-25-ns pa2 tc">
                <img src={image6} className="preConferenceImage" alt="image6" />
              </div>
              <div className="fl w-100 w-25-ns pa2 tc">
                <img src={image7} className="preConferenceImage" alt="image7" />
              </div>
              <div className="fl w-100 w-25-ns pa2 tc">
                <img src={image8} className="preConferenceImage" alt="image8" />
              </div>
              
              <div className="fl w-100 w-25-ns pa2 tc">
                <img src={image9} className="preConferenceImage" alt="image9" />
              </div>
              <div className="fl w-100 w-25-ns pa2 tc">
                <img src={image10} className="preConferenceImage" alt="image10" />
              </div>
              <div className="fl w-100 w-25-ns pa2 tc">
                <img src={image11} className="preConferenceImage" alt="image11" />
              </div>
              <div className="fl w-100 w-25-ns pa2 tc">
                <img src={image12} className="preConferenceImage" alt="image12" />
              </div>
              
              <div className="fl w-100 w-25-ns pa2 tc">
                <img src={image13} className="preConferenceImage" alt="image13" />
              </div>
              <div className="fl w-100 w-25-ns pa2 tc">
                <img src={image14} className="preConferenceImage" alt="image14" />
              </div>
              <div className="fl w-100 w-25-ns pa2 tc">
                <img src={image15} className="preConferenceImage" alt="image15" />
              </div>
              <div className="fl w-100 w-25-ns pa2 tc">
                <img src={image16} className="preConferenceImage" alt="image16" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/apps/BCOMS/pages/EventsWorkshop.tsx